import { rainbowDistortion } from './rainbowDistortion.js';

/**
 * Applies rainbow-style distortion
 * @param {number} x - X coordinate
 * @param {number} y - Y coordinate
 * @param {number} width - Canvas width
 * @param {number} height - Canvas height
 * @returns {Object} Distorted point {x, y}
 */
export const distortB = (x, y, width, height) => {
  if (x && y) {
    const normalX = x / width;
    const normalY = y / height;
    const distortXY = {
      x: rainbowDistortion(normalX, normalY).x * width,
      y: rainbowDistortion(normalX, normalY).y * height
    };
    return { x: x + distortXY.x, y: y + distortXY.y };
  } else {
    return { x, y };
  }
};